import { PublicPage } from "@/components/PublicPage";

export default function TransfertAutoEcole() {
  return (
    <PublicPage
      eyebrow="Changer d'auto-école"
      title="Transfère ton dossier vers une meilleure auto-école"
      intro="Ton auto-école ne te donne pas de date, a fermé, ou ne te convient plus ? On t'aide à transférer ton dossier vers une auto-école partenaire qui reprend ta formation là où tu en es."
      bullets={[
        { title: "On récupère tes acquis", sub: "Code, heures effectuées : tu ne repars pas de zéro." },
        { title: "Reprise rapide", sub: "Une auto-école partenaire reprend ton dossier sans perdre de temps." },
        { title: "Accompagnement du transfert", sub: "On te guide sur les démarches à prévoir." },
        { title: "Simple et sans engagement", sub: "Tu choisis en toute liberté." },
      ]}
      ctaLabel="Transférer mon dossier"
    />
  );
}
